<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  text?: string
  undoCallback?: () => void
}

const { text = 'Toast', undoCallback = () => {} } = defineProps<Props>()

const { t } = useI18n()
</script>

<template>
  <div class="undo-toast-root">
    <span class="text">{{ text }}</span>

    <button class="btn tertiary font-medium brand p-00" @click="undoCallback">
      {{ t('common.undo') }}
    </button>
  </div>
</template>

<style scoped>
.undo-toast-root {
  display: flex;
  gap: var(--size-1);
  align-items: center;

  color: var(--gray-12);
}

.text {
  flex: 1;
  font-variation-settings: 'wght' 500;
}

.btn.tertiary {
  margin: calc(var(--size-00) * -1);

  color: var(--brand-10);

  background: transparent;

  border-radius: 8px;

  transition: background 0.1s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
}
</style>
